export class OpenFormStore implements Storage {
  readonly storage: Storage;
  readonly namespace: (key?: string) => string;

  constructor(storage: Storage, ...namespace: string[]) {
    this.storage = storage;
    this.namespace = key => namespace.concat(key!).filter(Boolean).join(':');
  }

  get keys() {
    return Object.keys(this.storage).filter(key => key.startsWith(this.namespace()));
  }

  get length() {
    return this.keys.length;
  }

  clear() {
    this.keys.forEach(key => this.storage.removeItem(key));
  }

  getItem(key: string) {
    return this.storage.getItem(this.namespace(key));
  }

  hasItem(key: string) {
    return this.namespace(key) in this.storage;
  }

  key(index: number) {
    return this.keys[index] ?? null;
  }

  removeItem(key: string) {
    this.storage.removeItem(this.namespace(key));
  }

  setItem(key: string, value: string | null | undefined = null) {
    this.storage.setItem(this.namespace(key), value!);
  }
}
